export enum Color {
  PrimaryMain = "#FF867B",
  PrimaryDark = "#C8564F",
  PrimaryLight = "#FFB8AA",
  White = "#FFFFFF",
  Gray = "#BFBFBF",
  DarkGray = "#8A8A8A",
  LightGray = "#E4E4E4",
  LightYellow = "#FFF5E4",
  Yellow = "#FF9800",
  Body = "#363636",
  DetailsInput = "#727272",
  Headings = "#121212",
  BoxShadow = "#80808026",
  DoveBlue = "#8C9AB2",
  Error = "#E13737",
  ErrorLight = "#ffb6b6",
  LightBlue = "#E2EFFF",
  OffWhite = "#F8F8F8",
  CheckGreen = "#4CD964",
  DarkSeaGreen = "#8CB290",
  Brown = "#B29987",
  JeansBlue = "#3E586D",
  Information = "#2A6DDD",
  Powder = "#FCEBE0",
  Orange = "#ff9800",
  GreenLight = "#DAF8E6",
  LightOrange = "#feece1"
}
